/* eslint-disable react/prop-types */
import React, { useState, useEffect, MouseEvent } from "react";
import Grid from "@mui/material/Grid";
// import Modal from "@mui/material/Modal";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import Autocomplete from '@mui/material/Autocomplete';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import { FormLabel, Icon } from "@mui/material";

import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

import moment from "moment";
import { getDeclarations, generateShippingInv, API_ENDPOINT, generateAddressDocument, getPackages, generateBillingInvoice } from "network/service";
let status_options = [
    { name: "Picked Up", value: 0 },
    { name: "In Transit", value: 1 },
    { name: "Deliverd", value: 2 }
]

let declaration_temps = [
    { name: "DHL" }
]

// Material Dashboard 2 React Components
function InvoicePopup(props) {
    const [notiDetails, setShowDetails] = useState({ show: false });
    const [status, setStatus] = useState(props.details.status);
    const [loading, setLoading] = useState(false);
    const [template, setTemplate] = useState("DHL");
    const [declarations, setDeclarations] = useState([]);
    const [declar, setDeclar] = useState(null);
    const [declaTemp, setDeclaTemp] = useState("DHL");
    const [item, setItem] = useState("");




    const closeSB = () => setShowDetails({ ...notiDetails, show: false });

    const handleChange = (event) => {
        console.log(event);
        switch (event.target.name) {

        }
    };

    const itemCheck =()=>{
        if (item=="") {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Description error", message: "Please enter description" });
            setLoading(false);
        }
        else{
            generateBillingInvoice({
                id: props.details._id,
                item: item
            }).then((resp) => {
                console.log(resp.data);
                window.open(`${API_ENDPOINT}${resp.data.file}`, "_blank");
                setLoading(false);
                props.handleclose();
            }).catch((err) => {
                console.log(err);
                setLoading(false);
            })
        }
    }

    const invoiceCheck =()=>{
        if (declar==null) {
            setShowDetails({ show: true, color: "error", icon: "warning", title: "Invoice declaration error", message: "Please select invoice declaration" });
            setLoading(false);
        }
        else{
            generateShippingInv({
                id: props.details._id,
                declaration: declar._id,
                template: template
            }).then((resp) => {
                console.log(resp.data);
                getPackages(`_id=${props.details._id}`).then((resp1) => {
                    console.log(resp1.data);
                    window.open(`${API_ENDPOINT}${resp1.data[0].shipping_invoice}`, "_blank");
                    setLoading(false);
                }).catch((err2) => {
                    setLoading(false);
                })
            }).catch((err) => {
                console.log(err);
                setLoading(false);
            })
        }
    }

    useEffect(() => {
        getDeclarations().then((resp) => {
            console.log(resp.data);
            setDeclarations(resp.data);
        }).catch((err) => {
            console.log(err);
        });
    }, [setDeclarations])

    useEffect(() => {
        console.log("modal useEffect");
        if (props.details) {

        }
    }, []);



    function isNumeric(value) {
        return /^\d+$/.test(value);
    }


    const renderSB = (
        <MDSnackbar
            color={notiDetails.color}
            icon={notiDetails.icon}
            title={notiDetails.title}
            content={notiDetails.message}
            dateTime=""
            open={notiDetails.show}
            onClose={closeSB}
            close={closeSB}
            bgWhite
        />
    );




    return (
        <Dialog
            id="modal-display"
            open={props.isopen}
            aria-labelledby="form-dialog-title"
            aria-describedby="modal-modal-description"
            maxWidth="90%"
            onClose={props.handleclose}
        >
            <DialogContent style={{ width: 700, height: 'auto' }}>
                <FormGroup>
                    <MDBox component="form" noValidate width="100%">
                        <MDTypography
                            variant="h5"
                            fontWeight="bold"
                            color="dark"
                        >
                            {"Downloads"}
                        </MDTypography>
                        <Grid
                            container xs={12}
                            direction='row'
                            width={"100%"}
                            className="form-wrapper"
                            style={{ display: 'flex', alignItems: 'center', justifyContent: "space-around", margin: 10 }}
                        >
                            <Grid item xs={3} className="form-content">
                                <MDButton variant="outlined" color="success" style={{ width: "100%" }}
                                    disabled={(!(props.details.billing_invoice) || (loading))}
                                    onClick={() => {
                                        console.log(props.details.billing_invoice);
                                        window.open(`${API_ENDPOINT}${props.details.billing_invoice}`, "_blank");
                                    }}>
                                    <Icon>download</Icon>&nbsp;
                                    Bill
                                </MDButton>
                            </Grid>
                            <Grid item xs={3} className="form-content">
                                <MDButton variant="outlined" color="success" style={{ width: "100%" }}
                                    disabled={(!(props.details.shipping_invoice) || (loading))}
                                    onClick={() => {
                                        console.log(props.details.shipping_invoice);
                                        window.open(`${API_ENDPOINT}${props.details.shipping_invoice}`, "_blank");
                                    }}>
                                    <Icon>download</Icon>&nbsp;
                                    Invoice
                                </MDButton>
                            </Grid>
                            <Grid item xs={3} className="form-content">
                                <MDButton variant="outlined" color="success" style={{ width: "100%" }}
                                    disabled={loading}
                                    onClick={() => {
                                        setLoading(true);
                                        generateAddressDocument({
                                            id: props.details._id,
                                            template: ""
                                        }).then((resp) => {
                                            console.log(resp.data);
                                            window.open(`${API_ENDPOINT}${resp.data.file}`, "_blank");
                                            setLoading(false);
                                            props.handleclose()
                                        }).catch((err) => {
                                            setLoading(false);
                                            console.log(err);
                                        })
                                    }}>
                                    <Icon>download</Icon>&nbsp;
                                    Address
                                </MDButton>
                            </Grid>
                            <Grid item xs={3} className="form-content">
                                <MDButton variant="outlined" color="warning" style={{ width: "100%" }}
                                    disabled={(!(props.details.vendor_label_file) || (loading))}
                                    onClick={() => {
                                        window.open(`${API_ENDPOINT}${props.details.vendor_label_file}`, "_blank");
                                    }}>
                                    <Icon>download</Icon>&nbsp;
                                    UPS Waybill
                                </MDButton>
                            </Grid>
                            <Grid item xs={3} className="form-content">
                                <MDButton variant="outlined" color="warning" style={{ width: "100%" }}
                                    disabled={(!(props.details.vendor_wfs_awb_file) || (loading))}
                                    onClick={() => {
                                        window.open(`${API_ENDPOINT}${props.details.vendor_wfs_awb_file}`, "_blank");
                                    }}>
                                    <Icon>download</Icon>&nbsp;
                                    WFS AWB
                                </MDButton>
                            </Grid>
                            <Grid item xs={3} className="form-content">
                                <MDButton variant="outlined" color="warning" style={{ width: "100%" }}
                                    disabled={(!(props.details.vendor_proforma_file) || (loading))}
                                    onClick={() => {
                                        window.open(`${API_ENDPOINT}${props.details.vendor_proforma_file}`, "_blank");
                                    }}>
                                    <Icon>download</Icon>&nbsp;
                                    Vendor Inv
                                </MDButton>
                            </Grid>
                        </Grid>
                        <FormLabel sx={{ margin: 10 }}>Bill</FormLabel>
                        <Grid
                            container xs={12}
                            direction='row'
                            width={"100%"}
                            className="form-wrapper"
                            style={{ display: 'flex', alignItems: 'center', justifyContent: "space-around", margin: 10 }}
                        >
                            <Grid item xs={5} className="form-content">
                                <MDInput sx={{ flex: "1", width: "100%" }} value={item} onChange={(e) => { setItem(e.target.value) }} label="Item description" />

                            </Grid>
                            <Grid item xs={5} className="form-content">
                                <MDButton variant="outlined" color="info" style={{ width: "100%" }}
                                    disabled={loading}
                                    onClick={() => {

                                        setLoading(true);
                                        itemCheck();
                                    }}>
                                    <Icon>download</Icon>&nbsp;
                                    Generate
                                </MDButton>
                            </Grid>
                        </Grid>
                        <FormLabel sx={{ margin: 10 }}>Invoice</FormLabel>
                        <Grid
                            container xs={12}
                            direction='row'
                            width={"100%"}
                            className="form-wrapper"
                            style={{ display: 'flex', alignItems: 'center', justifyContent: "space-around", margin: 10 }}
                        >
                            <Grid item xs={3} className="form-content">
                                <FormControl sx={{ flex: "1", width: "100%" }}>
                                    <InputLabel id="demo-simple-select-label">Template</InputLabel>
                                    <Select
                                        // defaultValue=""
                                        // IconComponent={() => { return (<ArrowDropDown />) }}
                                        style={{ height: "1.4375em", padding: 20, marginRight: 10 }}
                                        onChange={(event) => {
                                            console.log(event.target.value);
                                            setTemplate(event.target.value);
                                        }}
                                        displayEmpty
                                        label={"Template"}
                                        value={template}
                                        inputProps={{ 'aria-label': 'Without label' }}
                                    >
                                        <MenuItem value={"DHL"}>DHL</MenuItem>
                                        <MenuItem value={"Others"}>Others</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3} className="form-content">
                                <Autocomplete
                                    disableClearable
                                    style={{ flex: "7", margin: 5 }}
                                    label="Declaration"
                                    options={declarations}
                                    getOptionLabel={(option) => option.name || ''}
                                    renderInput={(params) => <MDInput {...params} label="Declaration" />}
                                    onChange={(event, newValue) => {
                                        setDeclar(newValue);
                                    }}
                                    value={declar}
                                />
                            </Grid>
                            <Grid item xs={3} className="form-content">
                                <MDButton variant="outlined" color="info" style={{ width: "100%" }}
                                    disabled={loading}
                                    onClick={() => {
                                        
                                        setLoading(true);
                                        invoiceCheck();
                                        
                                    }}>
                                    <Icon>download</Icon>&nbsp;
                                    Generate
                                </MDButton>
                            </Grid>
                        </Grid>

                        <FormLabel sx={{ margin: 10 }}>Declaration</FormLabel>
                        <Grid
                            container xs={12}
                            direction='row'
                            width={"100%"}
                            className="form-wrapper"
                            style={{ display: 'flex', alignItems: 'center', justifyContent: "space-around", margin: 10 }}
                        >
                            <Grid item xs={5} className="form-content">
                                <FormControl sx={{ flex: "1", width: "100%" }}>
                                    <InputLabel id="demo-simple-select-label">Template</InputLabel>
                                    <Select
                                        // defaultValue=""
                                        // IconComponent={() => { return (<ArrowDropDown />) }}
                                        style={{ height: "1.4375em", padding: 20, marginRight: 10 }}
                                        onChange={(event) => {
                                            console.log(event.target.value);
                                            setDeclaTemp(event.target.value);
                                        }}
                                        displayEmpty
                                        label={"Template"}
                                        value={declaTemp}
                                        inputProps={{ 'aria-label': 'Without label' }}
                                    >
                                        <MenuItem value={"DHL"}>DHL</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={5} className="form-content">
                                <MDButton variant="outlined" color="info" style={{ width: "100%" }}
                                    disabled={loading}
                                    onClick={() => {
                                        setLoading(true);
                                        generateAddressDocument({
                                            id: props.details._id,
                                            template: declaTemp
                                        }).then((resp) => {
                                            console.log(resp.data);
                                            window.open(`${API_ENDPOINT}${resp.data.file}`, "_blank");
                                            setLoading(false);
                                            props.handleclose()
                                        }).catch((err) => {
                                            setLoading(false);
                                            console.log(err);
                                        })
                                    }}>
                                    <Icon>download</Icon>&nbsp;
                                    Download
                                </MDButton>
                            </Grid>
                        </Grid>

                        <Grid
                            container xs={12}
                            direction='row'
                            width={"100%"}
                            className="form-wrapper"
                            style={{ display: 'flex', alignItems: 'center', justifyContent: "flex-end", marginTop: 20 }}
                        >

                        </Grid>
                        {renderSB}
                    </MDBox>
                </FormGroup>
            </DialogContent>
        </Dialog >
    )
};

export default InvoicePopup;